<template>
  <v-container>
   <v-layout column>
    <h2 class="headline">Blitz Form Constructor</h2>
     <p><strong> Warning!</strong> <br/>
       You should use fields with next Property in your form constructor: name and email, companyName <br/>
       If you remove these fields from the invitation form - admin will still have to update this information while manual adding of company.</p>
    <FormConstructor/>
  </v-layout>
  </v-container>
</template>

<script>
import FormConstructor from '@/components/shared/EvFormConstructor'

export default {
  name: 'BlitzForm',
  components: {
    FormConstructor
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Blitz/Settings/blitzFormConstructor.vue